if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 768px)');
      if (document.body.matches('.page-product.temp--lightwrap-modern-template,.page-product.temp--lightwrap-new')) {
        this.adaptiveList = this.elements.viewer.querySelector('.product__media-list');
        this.adaptiveSlide = this.adaptiveList?.querySelector('.is-active');
        this.scheduleMobileHeight = () => {
          if (this.adaptiveFrame) return;
          this.adaptiveFrame = requestAnimationFrame(() => { this.adaptiveFrame = 0; this.updateMobileHeight(); });
        };
        this.onMediaBreakpoint = () => {
          this.adaptiveSlide = this.adaptiveList?.querySelector('.is-active') || this.adaptiveSlide;
          this.scheduleMobileHeight();
        };
        this.adaptiveObserver = new ResizeObserver(this.scheduleMobileHeight);
        this.elements.viewer.addEventListener('slideChanged', event => {
          this.adaptiveSlide = event.detail.currentElement;
          this.updateMobileHeight();
        });
        this.updateMobileHeight();
      }
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    connectedCallback() {
      if (!this.adaptiveObserver) return;
      this.querySelectorAll('.product-media-container').forEach(media => this.adaptiveObserver.observe(media));
      this.mql.addEventListener('change', this.onMediaBreakpoint);
      this.scheduleMobileHeight();
    }

    disconnectedCallback() {
      this.adaptiveObserver?.disconnect();
      if (this.scheduleMobileHeight) this.mql.removeEventListener('change', this.onMediaBreakpoint);
      if (this.adaptiveFrame) cancelAnimationFrame(this.adaptiveFrame);
      this.adaptiveFrame = 0;
    }

    updateMobileHeight() {
      if (!this.adaptiveList) return;
      if (this.mql.matches) { this.adaptiveList.style.height = ''; return; }
      const slide = this.adaptiveSlide;
      const media = slide?.querySelector('.product-media-container');
      if (!media) return;
      const listStyle = getComputedStyle(this.adaptiveList);
      const slideStyle = getComputedStyle(slide);
      const height = media.getBoundingClientRect().height + parseFloat(slideStyle.paddingTop) + parseFloat(slideStyle.paddingBottom) + parseFloat(listStyle.paddingTop) + parseFloat(listStyle.paddingBottom);
      const nextHeight = `${Math.ceil(height)}px`;
      if (height > 0 && this.adaptiveList.style.height !== nextHeight) this.adaptiveList.style.height = nextHeight;
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
      if (this.adaptiveList) { this.adaptiveSlide = activeMedia; this.updateMobileHeight(); }

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
